import React, { useState } from 'react';
import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CustomTextField from '../../../views/shared/CustomTextField';
import CustomSwitch from '../../../views/shared/CustomSwitch';
import VimeoIcon from './VimeoIcon';
import VimeoPickerModal from './VimeoPickerModal';
import CustomPopupText from '../../../views/shared/CustomPopupText';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    padding: '16px 20px',
    backgroundColor: '#FEFEFE',
    borderRadius: 12,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  orDivider: {
    textAlign: 'center',
    color: '#999',
    fontSize: 12,
    letterSpacing: 1,
  },
  browseButton: {
    alignSelf: 'center',
    borderRadius: 24,
    borderColor: '#6c63ff',
    color: '#622FEE',
    textTransform: 'none',
    padding: '8px 12px',
    fontSize: '14px',
    fontWeight: 500,
    gap: 8,
  },
}));

export const VideoLinkInput = ({
  value = '',
  onChange,
  label = 'Is there a Link?',
  placeholder = 'Enter link here',
  disabled = false,
  enabled: enabledProp,
  onEnabledChange,
}) => {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(false);
  const isControlled = enabledProp !== undefined;
  const [internalEnabled, setInternalEnabled] = useState(true);
  const enabled = isControlled ? enabledProp : internalEnabled;

  const handleToggle = (checked) => {
    if (!isControlled) setInternalEnabled(checked);
    onEnabledChange?.(checked);
  };

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <CustomPopupText text={label} />
        <CustomSwitch checked={enabled} handleChange={(e) => handleToggle(e.target.checked)} disabled={disabled} />
      </div>

      {enabled && (
        <>
          <CustomTextField
            value={value}
            handleChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            disabled={disabled}
            width="100%"
          />

          <Typography className={classes.orDivider}>OR</Typography>

          <Button
            variant="outlined"
            className={classes.browseButton}
            onClick={() => setModalOpen(true)}
            disabled={disabled}
          >
            Browse on&nbsp;
            <VimeoIcon width={50} height={14} />
          </Button>
        </>
      )}

      <VimeoPickerModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSelect={(url) => {
          onChange(url);
          setModalOpen(false);
        }}
      />
    </div>
  );
};

export default VideoLinkInput;
